export default __webpack_public_path__ + "static/media/background_desktop.98387204.webp";